import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Log, LogTag} from '../../services/Log';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {lastMap} from "../../rxjs/lastMap";
import {catchError, tap} from "rxjs/operators";
import {Expiration} from "../../interfaces/Expiration";

@Component({
  selector: 'app-ext-image',
  template: '<div #component (click)="onClick($event)"></div>',
  styleUrls: []
})
export class ExtImageComponent extends PlayerBase {
  genericElm: GenericElm;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    const logInfo = Log.getLogInfo("ExtImageComponent", "load", []);
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW)
          return of(null);
        } else {
          this.genericElm = new GenericElm(this.component);
          const url = this.data.LINK[0].$.src;
          return of(url);
        }
      }),
      switchMap( path => {
        if (path==null) {
          Log.w(logInfo, LogTag.PLAYER, "path is empty");
          return of(null);
        }

        let aspectRatio = (this.data.LINK[0].AspectRatio[0].$.maintain == 1);
        return this.genericElm.setImage(path, aspectRatio, this.actualWidth, this.actualHeight);

      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}
